import { render, staticRenderFns } from "./TaxStrategy.vue?vue&type=template&id=0f240f2c&"
import script from "./TaxStrategy.vue?vue&type=script&lang=ts&"
export * from "./TaxStrategy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports